import { Set } from 'immutable';

import { Permission } from './permission-config-list.entity';

interface IPermissionConfigEntity {
	id: number;
	element: string;
	permissions: Set<Permission>;
	allToggled: boolean;
}

const entityDefaults: IPermissionConfigEntity = {
	id: -1,
	element: '',
	permissions: Set(),
	allToggled: false,
};

export class PermissionConfigItemEntity implements IPermissionConfigEntity {
	public id = entityDefaults.id;
	public element = entityDefaults.element;
	public permissions = entityDefaults.permissions;
	public allToggled = entityDefaults.allToggled;

	public static build(
		params: Partial<IPermissionConfigEntity> = {}
	): PermissionConfigItemEntity {
		const permission = new PermissionConfigItemEntity();
		permission.id = params.id ?? entityDefaults.id;
		permission.element = params.element ?? entityDefaults.element;
		permission.permissions = params.permissions ?? entityDefaults.permissions;
		permission.allToggled = params.allToggled ?? entityDefaults.allToggled;
		return permission;
	}

	public updatePermission(
		checked: boolean,
		permission: Permission,
		availablePermissions: Array<Permission>
	): void {
		this.permissions = checked
			? this.permissions.add(permission)
			: this.permissions.delete(permission);

		this.allToggled = availablePermissions.every((permission) =>
			this.permissions.has(permission)
		);
	}

	public updateAllToggled(availablePermissions: Array<Permission>): void {
		this.allToggled = availablePermissions.every((permission) =>
			this.permissions.has(permission)
		);
	}

	public updatePermissions(permissions: Array<Permission>): void {
		this.permissions = Set<Permission>(permissions);
	}
}
